module.exports = __webpack_public_path__ + "media/images/location-9b8e5ba6dfdf21f144173ae175d12814.svg";